export default function AdGenerater (props) {
  const areaCheck = props.id;
  let srcUrl;

  if (areaCheck === 'top') {
    srcUrl = '/html/pc/top.htm';
  } else if (areaCheck === 'middle') {
    srcUrl = '/html/pc/middle.htm';
  } else if (areaCheck === 'live') {
    srcUrl = '/html/pc/live.htm';
  } else {
    srcUrl = '/html/pc/bottom.htm';
  }

  return (
    <div className={(areaCheck === 'live') ? 'contents_area_ad' : 'main_contents_ad'} id={(areaCheck === 'live') ? 'contents_area_ad' : 'main_contents_ad'}>
      <div className='ad_banner_w'>
        <iframe title='배너광고' display='block' src={srcUrl} width='970px' height='90px' scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />
      </div>
    </div>
  );
}
